import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UnderwritingService {
  private readonly uri: string = `${environment.DO_URL}/v2`;
  private http = inject(HttpClient);
  constructor() { }

  createUnderwriting(
		underwriting: any, subform: any
	): Observable<any> {
		const data = {
			underwriting, subform
		};
		return this.http.post(`${this.uri}/createUnderwriting`, data);
	}

  getDailyStat(input_date: string): Observable<any> {
	return this.http.get(`${this.uri}/underwriters/daily_stats/${input_date}`);
  }
}
